<button class="toggle-sidenav-btn" (click)="toggleNavShown()" mat-icon-button>
  <app-svg-icon fill="header-button" icon="nav" size="small"></app-svg-icon>
</button>
<account-select e2e="admin-toolbar-fragment"></account-select>
